import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CircleNotch } from "@phosphor-icons/react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--bg)" }}>
        <CircleNotch size={32} className="animate-spin" color="var(--accent)" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
